module.exports = "div.typeahead-choices {\n    z-index: 10;\n    position: absolute;\n    display: block;\n}\n\ndiv.typeahead {\n    position:relative;\n}\n\ninput.ng-invalid, textarea.ng-invalid {\n    border-color: red;\n}\n\nspan.match {\n    color: blue;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/articles/item/item.component.css
// module id = ./src/app/articles/item/item.component.css
// module chunks = main